import React from 'react';
import classnames from 'classnames';
import Form from 'react-bootstrap/Form';
import PerfectScrollbar from 'react-perfect-scrollbar'
import _ from 'lodash';

import BackButton from './BackButton';
import FilterButton from './FilterButton';
import Icon from '../Icon';

const thicknessKeys = [
  'thickness_1_0mm',
  'thickness_1_4mm',
  'thickness_2_0mm',
];

const FiltersSecondaryMenuFilterThickness = ({
  i18n,
  show,
  toggleCurrentThickness,
  currentThicknesses,
  showFilter,
  setShowFilter,
}) => {
  const filter = 'thickness';
  const { configurator_filters, configurator_thickness_filters } = i18n;
  const className = classnames(
    'FiltersSecondaryMenuFilterThickness',
    'FiltersSecondaryMenuFilterSection',
    'thickness',
    { show }
  );

  const handleClick = (id) => { toggleCurrentThickness(id); };

  return (
    <div className={className}>
      <PerfectScrollbar style={{}} className="container">
        <div className="row mb-2">
          <div className="col-sm-4">
            <div className="d-none">
              <div className="FiltersSecondaryMenuFilterSection__filterImage" />
              <h6 className="FiltersSecondaryMenuFilterSection__filterLabel">
                {configurator_filters[filter]}
              </h6>
            </div>
            <h5 className="FiltersSecondaryMenuFilterSection__filterTitle">
              {configurator_filters[filter]}
            </h5>
          </div>

          <div className="col-sm-8 text-end">
            <BackButton
              showFilter={showFilter}
              setShowFilter={setShowFilter}
            />
          </div>
        </div>

        <div className="row">
          {
            thicknessKeys.map((key) => (
              <div className="col-sm-4" key={key}>
                <FilterButton
                  key={key}
                  onClick={(event) => (handleClick(key))}
                  className={`${key} my-3`}
                  label={configurator_thickness_filters[key]}
                  active={_.includes(currentThicknesses, key)}
                />
              </div>
            ))
          }
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default FiltersSecondaryMenuFilterThickness;
